import axios from "axios";
import { msalInstance } from "../msalInstance";
import { loginRequest } from "../authConfig";

let activeRequests = 0;

let interceptorConfigured = false;

const configureHttpInterceptor = (setIsLoading) => {
  if (interceptorConfigured) return;
  interceptorConfigured = true;

  axios.interceptors.request.use(
    async (config) => {
      // Acquisisce sempre un token fresco tramite MSAL invece di usare quello
      // salvato in cookie al login: l'access token AAD dura molto meno delle
      // 24h del cookie, quindi affidarsi al cookie causava logout casuali
      // quando il token in esso contenuto scadeva. acquireTokenSilent rinnova
      // automaticamente il token usando il refresh token quando necessario.
      const account =
        msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
      if (account) {
        try {
          const { accessToken } = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account,
          });
          config.headers.Authorization = `Bearer ${accessToken}`;
        } catch (error) {
          console.error("Silent token acquisition failed:", error);
        }
      }
      if (activeRequests === 0) {
        setIsLoading(true);
      }
      activeRequests++;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );


  axios.interceptors.response.use(
    (response) => {
      activeRequests--;
      if (activeRequests === 0) {
        setIsLoading(false);
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 250);
      }

      return response;
    },
    (error) => {
      activeRequests--;
      if (activeRequests === 0) {
        setIsLoading(false);
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 250);
      }
      if (error.status === 401) {
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};

export default configureHttpInterceptor;
